define(['jquery', 'c21/ajax', 'c21/LoadingIndicator', 'jqueryenter'], function ($, ajax, LoadingIndicator) {
   "use strict";

   /**
    * @param sAjaxId Selector for the element seen by the user as performing the AJAX request
    *                A loading indicator will be placed on this element.
    *
    * @param sViewEngine the view engine name (EX: "/finehomes/fhefindahome.c21")
    * @param oDefaultValues any default values on the form (EX: {})
    * @param bFocusOnLoad
    * @param bCacheResult
    */
   return function(sAjaxId, sViewEngine, sScope, oDefaultValues, bFocusOnLoad, bCacheResult) {
      var m_jEl = (typeof sAjaxId === "string") ? $(sAjaxId) : sAjaxId;

      if (!oDefaultValues) {
         oDefaultValues = {};
      }

      function submit(options) {
         var oParams = $.extend(getQueryParameters(), {
               submitted: 'true'
            });

         if ($(document.body).hasClass("pageEcoIdx")) {
            var o = ajax.getParameters();
            oParams = $.extend(oParams, {
               obid: o.obid,
               feed: o.feed
            });
         }

         m_jEl.bind("portalAjaxLoadEvent", emulateFormBehavior);
         ajax.fetchView($.extend({
            url: sViewEngine,
            query: $.param(oParams),
            cache: bCacheResult,
            loadingIndicator: new LoadingIndicator(sAjaxId),
            callback: function (response) {
               m_jEl.find(".pageFormError").remove();
               m_jEl.find(".pageFormInputError").removeClass("pageFormInputError");

               $.each(response, function (i, oInstruction) {
                  var jError,
                     jInput,
                     jGeneralErrors;

                  if (oInstruction.action === "error") {
                     jError = $("<span>", {
                           id: oInstruction.field + "-error",
                           "class": "pageFormError"
                        }).attr("data-error", JSON.stringify(oInstruction));

                     $.each(oInstruction.messages, function (i, strMessage) {
                        if (strMessage === "") return;

                        var jMessage = $("<span>", {
                              className: "pageFormErrorMessage",
                              text: strMessage
                           });

                        jError.append(jMessage);
                     });

                     jInput = $("#" + (sScope ? sScope + "-" : "") + oInstruction.field.replace(/\./g, "\\.")).eq(0);
                     if(jInput.attr("id") === undefined) {
                        jInput = $("label[for='"+oInstruction.field+"']");
                        jInput = jInput.parent().find("input:last");
                     }

                     if (jInput.parent().is('label')) {
                        jInput = jInput.parent();
                     }
                     if (jInput.length > 0) {
                        jInput.addClass("pageFormInputError").after(jError);
                     } else {
                        if (!jGeneralErrors) {
                           jGeneralErrors = m_jEl.find(".pageFormGeneralErrors");
                           if (jGeneralErrors.length === 0) {
                              jGeneralErrors = $("<div>", {
                                    "class": "pageFormGeneralErrors"
                                 });

                              m_jEl.prepend(jGeneralErrors);
                           }
                        }

                        jGeneralErrors.append(jError);
                     }
                  }
               });
            }
         }, options || {}));
      }

      function clear() {
         m_jEl.find("input").each(function() {
            var jInput = $(this),
               sType = jInput.attr("type"),
               sId = getId(jInput),
               sAlt = jInput.attr("alt"),
               sDef = oDefaultValues[sId];

            if (!sDef) {
               sDef = sAlt;
            }

            if (sType === "text" || sType === "password" || sType === "email" || sType === "tel") {
               if (sDef) {
                  jInput.val(sDef);
               } else {
                  jInput.val("");
               }
            } else if (sType === "radio" || sType === "checkbox") {
               jInput.attr("checked", (sDef ? sDef : false));
            } else if (sType === "button" || sType === "submit" || sType === "hidden") {
            }
         });

         m_jEl.find("textarea, select").each(function() {
             var jInput = $(this), sId = jInput.attr("id"), sDef = oDefaultValues[sId];
             jInput.val(sDef);
         });
      }

      function emulateFormBehavior() {
         m_jEl.unbind("portalAjaxLoadEvent", emulateFormBehavior);
         var bFirst = true;
         m_jEl.find("input, select").each(function() {
            var jInput = $(this), sType = jInput.attr("type");
            jInput.enter(submit);

            if (bFirst && sType !== "hidden") {
               if (bFocusOnLoad) {
                  jInput.focus();
               }
               bFirst = false;
            }
         });

         m_jEl.find(".pageFormSubmit").click(submit);
      }

      function getQueryParameters() {
         var aParams = {};

         m_jEl.find("input").each(function() {
            var jInput = $(this),
               sType = jInput.attr("type"),
               sId = getId(jInput);

            if (sType === undefined || sType === "text" || sType === "email" || sType === "tel" || sType === "password" || sType === "hidden") {
               aParams[sId] = jInput.val();
            } else if (sType === "radio") {
               if (jInput.is(":checked")) {
                  aParams[getName(jInput)] = jInput.val();
               }
            } else if (sType === "checkbox") {
               if (jInput.is(":checked")) {
                  aParams[sId] = jInput.val();
               }
            } else if (sType === "button" || sType === "submit") {
               // do nothing
            }
         });

         m_jEl.find("textarea, select").each(function() {
            var jInput = $(this), sId = getId(jInput);
            aParams[sId] = jInput.val();
         });

         return aParams;
      }

      function getId(jEl) {
         return sScope ? jEl.attr('id').substring(sScope.length + 1) : jEl.attr('id');
      }

      function getName(jEl) {
         return sScope ? jEl.attr("name").substring(sScope.length + 1) : jEl.attr("name");
      }

      function initContactType() {
         var jRadio = m_jEl.find("input[name=contacttype\\.type]"),
             jPhone = m_jEl.find("#contacttype\\.phone"),
             jEmail = m_jEl.find("#contacttype\\.email");

         if (jRadio && jPhone && jEmail) {
            jRadio.change(function() {
               switch (jRadio.filter(":checked").val()) {
                  case 'phone':
                     setPlaceholderRequired(jPhone, true);
                     setPlaceholderRequired(jEmail, false);
                     break;
                  case 'email':
                     setPlaceholderRequired(jPhone, false);
                     setPlaceholderRequired(jEmail, true);
                     break;
                  default:
                     setPlaceholderRequired(jPhone, true);
                     setPlaceholderRequired(jEmail, true);
                     break;
               }
            });
            jRadio.eq(0).change();
         }
      }

      function setPlaceholderRequired(jEl, bRequired) {
         var sPlaceholder = jEl.attr("placeholder"),
             i = sPlaceholder ? sPlaceholder.indexOf("*") : -1;
         if (i < 0 && bRequired) {
            jEl.attr('placeholder', " " + $.trim(sPlaceholder) + " *");
         } else if (i > 0 && !bRequired) {
            jEl.attr('placeholder', " " + $.trim(sPlaceholder.substring(0, i)));
         }

      }

      function initialize () {
         emulateFormBehavior();
         initContactType();
      }

      initialize();

      return {
         getQueryParameters : getQueryParameters,
         submit : submit,
         clear : clear
      };
   };
});
